module.exports = "<template>\n    <section>\n        <div class=\"buttons\">\n            <b-button tag=\"router-link\"\n                to=\"/documentation\"\n                type=\"is-link\">\n                Docs\n            </b-button>\n            <b-button tag=\"router-link\"\n                to=\"/expo\"\n                type=\"is-info\">\n                Expo\n            </b-button>\n        </div>\n    </section>\n</template>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/button/examples/ExRouter.vue
// module id = 1324
// module chunks = 21